import type { PaymentMetadata } from '@/apis/payment';
import { PAYMENT_METHOD_STYLE } from './order-shared';

export function formatPaymentMethod(method: string): string {
  return (
    PAYMENT_METHOD_STYLE[method.toLowerCase()]?.label ??
    method.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase())
  );
}

export interface PaymentVia {
  orderedVia: string | null;
  paidVia: string | null;
}

export function getPaymentVia(
  metadata: PaymentMetadata | null | undefined
): PaymentVia {
  const ordered =
    metadata?.latestPaymentMethod ?? metadata?.paymentMethod ?? null;
  const paid = metadata?.paidVia ?? null;
  return {
    orderedVia: ordered ? formatPaymentMethod(ordered) : null,
    paidVia: paid ? formatPaymentMethod(paid) : null,
  };
}

/** "Ordered via Credit Card · Paid via Check", or just the ordered method when no manual payment exists. */
export function formatPaymentVia(
  metadata: PaymentMetadata | null | undefined
): string | null {
  const { orderedVia, paidVia } = getPaymentVia(metadata);
  if (!paidVia) return orderedVia;
  return orderedVia
    ? `Ordered via ${orderedVia} · Paid via ${paidVia}`
    : `Paid via ${paidVia}`;
}
